import * as THREE from "three";
import _ from "lodash";

import { useLoader } from '@react-three/fiber';


export default function ObjectWrapper({gltf, configuration, instance}) {

    const { nodes, materials } = gltf;

    const style =  
        _.values(instance).reduce((aggr, next) => {
            if(next != null && 'material' in next)
                return _.merge(aggr, next.material);
            else
                return aggr
        }, {});

    var meshes = Object.values(nodes)
        .filter((o : any) => o.geometry !== undefined)
        .map((node : any) => {

        var material = node.material.clone();

       // node.scale.set(configuration.scale);

        if(_.has(style, material.name))
        {
            console.log("Setting style on "+material.name);
            if(_.has(style[material.name], "color"))
            {
                console.log('Set color: '+style[material.name].color)
                material.color.set(style[material.name].color);
            }
            if(_.has(style[material.name], "roughness"))
            {
                console.log('Set roughness: '+style[material.name].roughness);

                material.roughness = style[material.name].roughness;
            }
            if(_.has(style[material.name], "map2"))
            {
               // const map = useLoader(THREE.TextureLoader, style[material.id].map);
               // map.flipY = false;
               // material.map = map;
            }
            console.dir(material);
        }

        return (<mesh
                key={node.name}
                geometry={node.geometry} 
                material={material} 
                position={node.position}
                rotation={node.rotation}
                scale={node.scale}>
            </mesh>
        )
    })

    return (
        <group>{meshes}</group>
    )
}
